/** @format */

import React, {useContext} from 'react'

import Modal from '../components/tailwind/Modal'
import {STEPS} from './constants'
import {Elements} from '@stripe/react-stripe-js'
import {PaymentForm} from './PaymentForm'
import {CheckoutContext} from './CheckoutContext'
import {AccountContext} from '../contexts/AccountContext'

const formspree = window.formspree
const stripeInstance = Stripe(formspree.STRIPE_PUBLISHABLE_KEY)

export const PurchaseModal = props => {
  const {product, prefix, noMobileScroll} = props

  const {account, sub, card} = useContext(AccountContext)

  const {
    currentStep,
    prevStep,
    currentModal,
    closeModal,
    checkoutData
  } = useContext(CheckoutContext)

  return (
    <Modal
      title={
        <h4 className={'font-bold text-xl'}>
          {!sub && (
            <a
              className="text-gray-600 text-lg cursor-pointer"
              onClick={prevStep}
            >
              &lt; Back &nbsp;&nbsp;&nbsp;
            </a>
          )}
          Purchase {formspree.SERVICE_NAME} {product.name}
        </h4>
      }
      isOpen={
        currentModal === prefix + product.id && currentStep === STEPS.PAYMENT
      }
      onClose={closeModal}
      className="narrow"
      noMobileScroll={noMobileScroll}
    >
      <Elements stripe={stripeInstance}>
        <PaymentForm
          userHasSubAlreadySoDontAsk={account && sub && card}
          data={checkoutData}
          product={product}
        />
      </Elements>
    </Modal>
  )
}
